const EventTitle = ({ title }: { title: string }) => {
  return (
    <section className="font-normal flex flex-col items-center justify-center bg-gray-000 pt-20 leading-[21.6px] text-[18px]">
      {/* MMP에서 개행을 인지하지 못해서, \n -> \\n 으로 내려옴. 파싱을 위한 코드 */}
      <p className="whitespace-pre-wrap text-center text-[#0c1120] typo-title200-semibold">
        {title.replace(/\\n/g, '\n')}
      </p>
    </section>
  );
};

export default EventTitle;
